import { AlertTriangle, CalendarClock, ShieldAlert, ShieldCheck } from 'lucide-react';

import { CartaoIndicador } from './CartaoIndicador';
import type { GovernancaPrazos as DadosGovernancaPrazos } from './tipos';

/** Seção "Governança e prazos" — conformidade institucional e integridade dos registros. */
export function GovernancaPrazos({ dados }: { dados: DadosGovernancaPrazos }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      <CartaoIndicador
        titulo="Cumprimento de prazos"
        valor={`${dados.cumprimentoPct}%`}
        descricao={`${dados.prazosVencidos} vencido(s) · ${dados.prazosEmRisco} em risco`}
        icone={CalendarClock}
        tom={
          dados.prazosVencidos > 0 ? 'critico' : dados.prazosEmRisco > 0 ? 'atencao' : 'positivo'
        }
        to="/operacao/financeiro/fechamento-mensal"
      />
      <CartaoIndicador
        titulo="Glosas / devoluções"
        valor={dados.glosas}
        descricao="Demonstrativos recusados no período"
        icone={AlertTriangle}
        tom={dados.glosas > 0 ? 'atencao' : 'neutro'}
        to="/operacao/financeiro/demonstrativos"
      />
      <CartaoIndicador
        titulo="Integridade da auditoria"
        valor={dados.integridadeOk ? 'Íntegra' : `${dados.integridadeQuebras} quebra(s)`}
        descricao={
          dados.integridadeOk ? 'Cadeia SHA-256 verificada' : 'Encadeamento divergente — investigar'
        }
        icone={dados.integridadeOk ? ShieldCheck : ShieldAlert}
        tom={dados.integridadeOk ? 'positivo' : 'critico'}
        to="/operacao/financeiro/auditoria"
      />
      <CartaoIndicador
        titulo="Eventos auditoria 24h"
        valor={dados.auditoria24h}
        descricao={`${dados.auditoriaTotal} no total`}
        icone={ShieldCheck}
        to="/operacao/financeiro/auditoria"
      />
    </div>
  );
}
